// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Svg from "../../primitives/Svg.res.js";
import * as View from "../../primitives/View.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Dimensions from "../../primitives/Dimensions.res.js";
import * as ReactAria from "react-aria";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactStately from "react-stately";
import * as AnimatedRender from "../../primitives/AnimatedRender.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
function useTrigger(defaultOpenedOpt, modalPopoverOpt, param) {
  let defaultOpened = defaultOpenedOpt !== undefined ? defaultOpenedOpt : false;
  let modalPopover = modalPopoverOpt !== undefined ? modalPopoverOpt : false;
  let ref = React.useRef(null);
  let match = Hover.use(ref, undefined, undefined);
  let triggerHovered = match[1];
  let state = ReactStately.useOverlayTriggerState({
    defaultOpen: defaultOpened
  });
  let ariaProps = ReactAria.useOverlayTrigger({
    type: "dialog"
  }, state, ref);
  let state_isOpen = state.isOpen;
  let state_close = () => {
    if (!triggerHovered || modalPopover) {
      return state.close();
    }
  };
  let state_toggle = state.toggle;
  let state$1 = {
    isOpen: state_isOpen,
    close: state_close,
    toggle: state_toggle
  };
  return {
    state: state$1,
    ariaProps: ariaProps,
    ref: ref
  };
}
let make = React.memo(props => {
  let __ariaLabel = props.ariaLabel;
  let ariaLabel = __ariaLabel !== undefined ? __ariaLabel : "popover-dialog";
  let domRef = React.useRef(null);
  let match = ReactAria.useDialog({
    "aria-label": ariaLabel
  }, domRef);
  let props$1 = ReactAria.mergeProps(match.dialogProps, props.ariaProps);
  let newrecord = {
    ...props$1
  };
  return JsxRuntime.jsx(View.make, (newrecord.style = props.style, newrecord.className = props.className, newrecord.ref = Primitive_option.some(domRef), newrecord.children = props.children, newrecord));
});
let Dialog = {
  make: make
};
let context = React.createContext(undefined);
let make$1 = context.Provider;
let Provider = {
  make: make$1
};
let PopoverContextNotFound = /* @__PURE__ */Primitive_exceptions.create("Popover.Context.PopoverContextNotFound");
function use() {
  let state = React.useContext(context);
  if (state !== undefined) {
    return state;
  }
  throw {
    RE_EXN_ID: PopoverContextNotFound,
    Error: new Error()
  };
}
let styles = {
  root: {
    "position-kVAEAm": "position-x10l6tqk",
    "zIndex-kY2c9j": "zIndex-x1vjfegm",
    $$css: "wino-gc:src/resources/overlays/Popover.res.js:86"
  }
};
let make$2 = React.memo(props => {
  let crossOffset = props.crossOffset;
  let placement = props.placement;
  let arrowProps = props.arrowProps;
  let tmp;
  let exit = 0;
  if (placement === "bottom") {
    let left = arrowProps.style.left;
    if (left !== undefined) {
      tmp = {
        left: String(left + crossOffset - 8) + "px",
        top: "-10px"
      };
    } else {
      exit = 1;
    }
  } else if (placement === "right") {
    let top = arrowProps.style.top;
    if (top !== undefined) {
      tmp = {
        left: "-8px",
        top: String(top + crossOffset - 10) + "px"
      };
    } else {
      exit = 1;
    }
  } else if (placement === "top") {
    let left$1 = arrowProps.style.left;
    if (left$1 !== undefined) {
      tmp = {
        bottom: "-8px",
        left: String(left$1 + crossOffset - 10) + "px"
      };
    } else {
      exit = 1;
    }
  } else {
    let top$1 = arrowProps.style.top;
    if (top$1 !== undefined) {
      tmp = {
        right: "-8px",
        top: String(top$1 + crossOffset - 10) + "px"
      };
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    tmp = {};
  }
  let style = Stylex.props(styles.root, {
    transform: placement === "bottom" ? "rotate(0deg)" : placement === "right" ? "rotate(-90deg)" : placement === "top" ? "rotate(180deg)" : "rotate(90deg)"
  }, tmp);
  let newrecord = {
    ...style
  };
  return JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx(Svg.make, {
    children: JsxRuntime.jsx(Svg.Path.make, {
      d: "M 9.278 6.281 Q 9.989 5.718 10.7 6.281 L 19.741 13.437 Q 20.452 14 19.029 14 L 0.949 14 Q -0.474 14 0.237 13.437 Z",
      fill: "#fefefe",
      filter: "drop-shadow(rgba(0, 0, 0, 0.05) 0px -1px 1px)",
      stroke: "#d7d7e0",
      strokeDasharray: "13, 21"
    }),
    width: "16",
    height: "16",
    viewBox: "0 0 20 20"
  }), newrecord));
});
let styles$1 = {
  root: {
    "backgroundColor-kWkggS": "backgroundColor-x17suf5r",
    "borderColor-kVAM5u": "borderColor-x9r1u3d",
    "borderRadius-kaIpWk": "borderRadius-x1sxf85j",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderWidth-kMzoRj": "borderWidth-xmkeg23",
    "boxShadow-kGVxlE": "boxShadow-x160wcjz",
    "overflow-kVQacm": "overflow-xb3r6kr",
    $$css: "wino-gc:src/resources/overlays/Popover.res.js:165"
  }
};
function viewStyleFromParams(layout, size, triggerWidth, borderColor) {
  return Stylex.props(styles$1.root, {
    borderColor: borderColor,
    borderRadius: size === "compact" ? "3px" : "5px"
  }, layout === "triggerMinWidth" ? {
    minWidth: String(triggerWidth) + "px"
  } : layout === "triggerStrictWidth" ? {
    maxWidth: String(triggerWidth) + "px",
    minWidth: String(triggerWidth) + "px"
  } : {});
}
function isWithinNestedOverlay(element) {
  return Stdlib_Option.isSome(Primitive_option.fromNullable(element.closest(`[role="menu"], [data-select-content]`)));
}
function Popover(props) {
  let __crossOffset = props.crossOffset;
  let __offset = props.offset;
  let __modal = props.modal;
  let __shouldUpdatePosition = props.shouldUpdatePosition;
  let __dismissable = props.dismissable;
  let __overlayPriority = props.overlayPriority;
  let __layout = props.layout;
  let __placement = props.placement;
  let __size = props.size;
  let __borderColor = props.borderColor;
  let __variation = props.variation;
  let state = props.state;
  let triggerRef = props.triggerRef;
  let variation = __variation !== undefined ? __variation : "normal";
  let borderColor = __borderColor !== undefined ? __borderColor : "#d7d7e0";
  let size = __size !== undefined ? __size : "normal";
  let placement = __placement !== undefined ? __placement : "bottom";
  let layout = __layout !== undefined ? __layout : "auto";
  let overlayPriority = __overlayPriority !== undefined ? __overlayPriority : true;
  let dismissable = __dismissable !== undefined ? __dismissable : true;
  let shouldUpdatePosition = __shouldUpdatePosition !== undefined ? __shouldUpdatePosition : true;
  let modal = __modal !== undefined ? __modal : true;
  let offset = __offset !== undefined ? __offset : 3;
  let crossOffset = __crossOffset !== undefined ? __crossOffset : 0;
  let ref = Stdlib_Option.getOr(props.popoverRef, React.useRef(null));
  let shouldUpdatePosition$1 = shouldUpdatePosition || !shouldUpdatePosition && ref.current == null;
  let props$1 = ReactAria.mergeProps({
    triggerRef: triggerRef,
    popoverRef: ref,
    shouldUpdatePosition: shouldUpdatePosition$1,
    shouldCloseOnInteractOutside: element => {
      if (dismissable) {
        return !isWithinNestedOverlay(element);
      } else {
        return false;
      }
    },
    placement: placement,
    offset: size === "compact" ? offset - 1 : offset,
    crossOffset: crossOffset,
    isNonModal: !modal
  }, props.ariaProps);
  let match = Dimensions.use(triggerRef, undefined);
  let triggerWidth = match[1].width;
  let match$1 = ReactAria.usePopover(props$1, state);
  let placement$1 = match$1.placement;
  let popoverProps = match$1.popoverProps;
  let popoverProps$1 = ReactAria.mergeProps(popoverProps, {
    style: ReactAria.mergeProps(popoverProps.style, {
      zIndex: overlayPriority ? 1000 : 1
    })
  }, {
    onBlur: dismissable ? popoverProps.onBlur : undefined
  });
  let animation = Stdlib_Option.getOr(props.animation, placement$1 === "bottom" ? triggerWidth > 400 ? "fadeTranslation" : "fadeBubbleTranslation" : placement$1 === "right" ? "fadeBubbleTranslationFromLeft" : placement$1 === "top" ? triggerWidth > 400 ? "fadeTranslation" : "fadeBubbleTranslationFromBottom" : "fadeBubbleTranslationFromRight");
  let animationTransformOrigin = Stdlib_Option.map(Primitive_option.fromNullable(match$1.triggerAnchorPoint), param => String(param.x) + `px ` + String(param.y) + `px`);
  let newrecord = {
    ...popoverProps$1
  };
  newrecord.ref = Primitive_option.some(ref);
  let newrecord$1 = {
    ...viewStyleFromParams(layout, size, triggerWidth, borderColor)
  };
  newrecord.children = JsxRuntime.jsxs(AnimatedRender.make, {
    children: [variation === "normal" ? null : JsxRuntime.jsx(make$2, {
      arrowProps: match$1.arrowProps,
      placement: placement$1,
      crossOffset: crossOffset
    }), modal ? JsxRuntime.jsx(ReactAria.DismissButton, {
      onDismiss: state.close
    }) : null, JsxRuntime.jsx("div", (newrecord$1.children = props.children, newrecord$1)), modal ? JsxRuntime.jsx(ReactAria.DismissButton, {
      onDismiss: state.close
    }) : null],
    displayed: state.isOpen,
    animation: animation,
    duration: 125,
    transformOrigin: animationTransformOrigin
  });
  return JsxRuntime.jsx(make$1, {
    value: state,
    children: JsxRuntime.jsxs(ReactAria.Overlay, {
      children: [modal ? JsxRuntime.jsx("div", match$1.underlayProps) : null, JsxRuntime.jsx("div", newrecord)],
      shouldContainFocus: modal
    })
  });
}
let make$3 = React.memo(Popover, (oldProps, newProps) => {
  if (oldProps.state.isOpen === newProps.state.isOpen) {
    return !newProps.state.isOpen;
  } else {
    return false;
  }
});
let Context = {
  Provider: Provider,
  use: use
};
let useState = use;
export { useTrigger, Dialog, Context, useState, make$3 as make };
/* make Not a pure module */